import { Box, CircularProgress } from '@chakra-ui/react';
import { OperationStatus } from '../BulkOperationQueue.interface';
import { KText } from '@/ui-library/components/text';

interface StatusIndicatorProps {
  status: OperationStatus;
  progress?: number;
  errorType?: string;
}

const STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

/**
 * Common status indicator component
 * Shows circular progress for in_progress, checkmark for completed, error badge for failed
 */
export const StatusIndicator = ({
  status,
  progress: _progress = 0,
  errorType,
}: StatusIndicatorProps) => {
  if (status === STATUS.IN_PROGRESS) {
    // Show indeterminate spinner for in-progress operations
    // This provides better UX than an empty progress ring when progress is 0 or unknown
    return (
      <CircularProgress
        isIndeterminate
        size="20px"
        thickness="12px"
        color="primary-400"
        trackColor="secondary-200"
      />
    );
  }

  if (status === STATUS.COMPLETED) {
    return (
      <Box
        w="18px"
        h="18px"
        borderRadius="full"
        bg="#15B097"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 4L3.5 6.5L9 1"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>
    );
  }

  if (status === STATUS.FAILED) {
    return (
      <>
        {errorType && (
          <KText size="xs" color="pastel-1-dark">
            {errorType}
          </KText>
        )}
      </>
    );
  }

  // pending or unknown status - show nothing
  return null;
};
